
const CloseButton = ({ handleAction }) => {
    return (
        <button
            onClick={() => handleAction()}
            className="border-green-700 border-2 pr-2 pl-2 pb-1 pt-1 rounded">close</button>
    )
}
export default CloseButton;